/**
 * For maintainability we should separate controllers into their own modules
 */

angular.module('acme.view.application.reports.list.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.service.reportingApi',
  'acme.common.service.userPreferences',
  'acme.view.application.reports.list.createModal.controllers',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])
.controller('ReportsListController', ['$scope', '$state', '$filter', '$timeout', '$uibModal', 'ApiService', 'HelpersService', 'UserPreferencesService', 'GridStateFactory', 'GridDefinitionFactory', 'PermissionsService', 'ReportingConstant', function ($scope, $state, $filter, $timeout, $uibModal, ApiService, HelpersService, UserPreferencesService, GridStateFactory, GridDefinitionFactory, PermissionsService, ReportingConstant) {

  $scope.reportsList = {
    model: [],
    filtered: [],
    lastSearchQuery: '',
    searchQuery: '',
    viewId: '',
    reportsListGridName: $state.current.name+'.grid0',
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),
    isLoaded: false,

    optionsOverride: {
      data: 'reportsList.model',
      rowHeight: 42,
      appScopeProvider: {
        onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
          $scope.reportsList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function(grid, columns, page) {
          $scope.reportsList.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          $scope.reportsList.onDblClick(item);
        },
        getFromNow: function (item) {
          return $scope.reportsList.getFromNow(item);
        }
      },
      columnDefs:  [
        {
          field: 'id',
          displayName: 'ID',
          visible: false
        },
        {
          field: 'lastRun',
          displayName: 'Latest results',
          visible: true,
          cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()">' +
                        '<a data-ui-sref="application.reports.result({ definitionId: row.entity.id, resultId: row.entity.lastRun.id })">' +
                        '{{ grid.appScope ? grid.appScope.getFromNow(row.entity) : reportsList.optionsOverride.appScopeProvider.getFromNow(row.entity) }}' +
                        '</a></div>'
        },
        {
          field: 'name',
          displayName: 'Name',
          visible: true,
          sort: {
            direction: 'asc'
          },
          cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><div class="name">{{row.entity.name}}</div><div class="description">{{row.entity.description}}</div></div>'
        },
        {
          field: 'displayCollectionName',
          displayName: 'Report Type',
          visible: true
        },
        {
          field: 'updatedBy',
          displayName: 'Last Modified By',
          visible: true
        }
      ]
    },

    init: function () {
      var self = $scope.reportsList;

      $scope.$emit('Application::contentTitleChange', {
        title: 'Reports',
        buttonRight: {
          label: '+ Create Report',
          permissions: ['REPORTS_CREATE'],
          action: function () {
            self.addReport();
          }
        }
      });

      this.buildColumns();

      this.viewId = $state.current.name;
      this.gridDefinition.init(this.reportsListGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
      self.getDataSources();

      $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));

    },

    buildColumns: function() {
      var self = $scope.reportsList;

      if (PermissionsService.check('REPORTS_UPDATE')) {
        this.optionsOverride.columnDefs.unshift({
          field: 'edit',
          displayName: 'Action',
          width: 80,
          enableHiding: false,
          enableSorting: false,
          onCellNavClick: function(row, col) {
            $scope.reportsList.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">{{ (row.entity.acmeDefault) ? "View" : "View/Edit" }}<span class="sr-only">View or Edit details</span></a></div>'
        });
      }

      self.optionsOverride.columnDefs.push({
        field: 'displayCreatedOn',
        displayName: 'Date Created',
        visible: true,
        cellFilter: 'date : "' + self.dateTimeFormat + '"',
        cellFormatter: function(item) {
          return $filter('date')(item.value, self.dateTimeFormat);
        },
        colId: 'createdOn'
      });

      self.optionsOverride.columnDefs.push({
        field: 'displayUpdatedOn',
        displayName: 'Date Modified',
        visible: true,
        cellFilter: 'date : "' + self.dateTimeFormat + '"',
        cellFormatter: function(item) {
          return $filter('date')(item.value, self.dateTimeFormat);
        },
        colId: 'updatedOn'
      });
    },

    initData: function() {
      var self = $scope.reportsList, props = self.gridDefinition.getGridState();
      self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      self.getReportDefinitions();
    },

    getDataSources: function() {
      ApiService.reporting.datasources.list().then(this.success.dataSources, this.error.dataSources);
    },

    getReportDefinitions: function() {
      this.isLoaded = false;
      this.gridState.setPropertyValue('search', this.searchQuery);
      ApiService.reporting.definitions.list(this.gridState.getGridState()).then(this.success.getDefinitions, this.error.getDefinitions);
    },

    create: function () {
      ApiService.reporting.definitions.create(this.currentReport).then(this.success.create, this.error.create);
    },

    search: function() {
      var self = $scope.reportsList;
      self.gridState.setPropertyValue('search', self.searchQuery);
      $scope.$broadcast('DataGrid::Search', {name: self.reportsListGridName});
    },

    hasReports: function() {
      return (this.model instanceof Array && this.model.length > 0);
    },

    getFilteredDate: function(date) {
      return $filter('date')(new Date(date), "M/d/yyyy \'at\' h:mm a");
    },

    getFromNow: function(report) {
      var asyncReport = report.lastRun,
        result = '';

      if (asyncReport) {
        result = asyncReport.status === ReportingConstant.async.status.pending ?
          'Currently Processing' :
          moment(asyncReport.updatedOn).fromNow();
      }

      return result;
    },

    deleteReport: function(e, row, id) {
      console.log('delete: ', e, row, id);
      e.stopPropagation();
      $scope.reportsList.filtered.splice(row.rowIndex, 1);
      ApiService.reporting.definitions.remove(id).then($scope.reportsList.success.remove, $scope.reportsList.error.remove);
    },

    process: function(reports) {
      var i, ii;

      for (i=0,ii=reports.length;i<ii;i++) {
        reports[i].displayCreatedOn = new Date(reports[i].createdOn);
        reports[i].displayUpdatedOn = new Date(reports[i].updatedOn);
      }

      return reports;
    },

    addReport: function () {

      var self = $scope.reportsList;
      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/reports/list/modals/createReport.tpl.html',
        controller: 'ReportsListCreateModalController',
        resolve: {
          Reports: function() {
            return self.model;
          },
          Datasources: function() {
            return self.datasources;
          }
        }
      });

      // Invoked when modal completes with close(params)
      self.addModal.result.then(function (report) {

        self.currentReport = report;
        self.create();

      }, function () {
        // Do nothing
      });
    },
    
    success: {
      create: function (response) {
        $state.go('application.reports.create', { id: response.data.payload });
      },
      dataSources: function(response) {
        $scope.reportsList.datasources = response.data.payload.collectionDataList;
      },
      getDefinitions: function(response) {
        var self = $scope.reportsList;

        console.log(response.data.payload);
        self.model = self.process(response.data.payload.list);
        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;
        if (!$scope.$$phase) {
            $scope.$apply();
        }        
        //next tick
        $timeout(function() {
          $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
        },10);

      },
      remove : function(response) {

      }
    },
    error: {
      create: function (response) {

      },
      dataSources: function(response) {

      },
      getDefinitions: function(response) {
        var self = $scope.reportsList;

        self.isLoaded = true;
      },
      remove : function(response) {

      }
    },

    onDblClick: function(item) {
      $state.go('application.reports.create', { id: item.entity.id });
    },

    onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
      var self = $scope.reportsList;
      self.gridState.updateGridState(newPage, pageSize);
      if (sortField) {
        self.gridState.updateGridState(null, null, sortField, null);
      }
      if(sortDirection) {
        self.gridState.updateGridState(null, null, null, sortDirection);
      }
      self.getReportDefinitions();
    },

    onDataGridSortChange: function(grid, columns, page) {
      var self = $scope.reportsList, data = columns[0];
      self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
      self.getReportDefinitions();
    }
  };

  $scope.reportsList.init();
}]);